import { render } from "./PerfilView.vue?vue&type=template&id=5dc94323&ts=true"
import script from "./PerfilView.vue?vue&type=script&lang=ts"
export * from "./PerfilView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__